import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function FeatureSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            全面了解91破解版
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            从安全风险到替代方案，我们为您整理了关于91破解版最全面的信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-white rounded-lg p-6 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {cat.description}
              </p>
              <div className="flex items-center gap-1 mt-4 text-sm text-primary-500 font-medium">
                <span className="whitespace-nowrap">浏览文章</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}